import { SVGProps, Ref, forwardRef } from 'react';

export const TrainFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.981 11.1c-.116 4.808-.875 6.753-3.837 7.489L18.949 24h-1.896l-.567-1.7h-8.97L6.948 24H5.052l1.802-5.411c-2.96-.736-3.719-2.682-3.835-7.49zm-5.637 7.777c-.951.09-2.057.123-3.344.123s-2.394-.034-3.345-.123l-.54 1.623h7.77zM7.85 12.9a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m8.3 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 0c7.811 0 8.98 1.168 8.999 9.3H3.001C3.019 1.168 4.189 0 12 0M8.5 5.4h7V3.6h-7z"
                fill="currentColor"
            />
        </g>
    </svg>
));
TrainFilledSize24Glyph.displayName = 'TrainFilledSize24Glyph';
